import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["theme", "size", "children", "beforeIcon", "afterIcon", "fullWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { clsx } from 'clsx';
import { getTheme } from '../../themes';
import { useUiKitThemeContext } from '../../../internal/context';
import styles from '../../styles/shared.module.css';
import customStyles from '../../styles/linkButton.module.css';

/**
 * Компонент ссылки, визуально неотличимый от кнопки
 * Имеет настройки тем, размеров. Умеет отображать иконку и текст
 * встроен rel="noopener" для обеспечения безопасности (nofollow и noreferrer не включены по причинам SEO и аналитики)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LinkButtonComponent = /*#__PURE__*/React.forwardRef(function LinkButton(_ref, ref) {
  let {
      theme = 'fill_primary',
      size = 'M',
      children,
      beforeIcon,
      afterIcon,
      fullWidth
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    theme: globalTheme
  } = useUiKitThemeContext();
  const themeClasses = getTheme(theme);
  const containerClasses = clsx(styles['button'], customStyles['link-button'], styles[size], themeClasses['button'], themeClasses[globalTheme], {
    [styles['full-width']]: fullWidth,
    [styles['button--before-icon']]: beforeIcon,
    [styles['button--after-icon']]: afterIcon
  });
  return /*#__PURE__*/_jsxs("a", _objectSpread(_objectSpread({
    className: containerClasses,
    rel: "noopener"
  }, rest), {}, {
    ref: ref,
    children: [beforeIcon, children && /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      children: children
    }), afterIcon]
  }));
});
export const LinkButton = /*#__PURE__*/React.memo(LinkButtonComponent);